/**
 * The frame every back-office page draws itself in: the whole width of the
 * shell's main area, or — for a form — a 600px column centred in it.
 *
 * One function, read by `ManagePage` (the page) and by `ManageShell` (the box
 * that stands in for the page while its chunk loads), so the placeholder lines
 * up with the page's own edges by construction rather than by matching numbers.
 */
export type PageFrameWidth = "list" | "form";

export function pageFrameClass(width: PageFrameWidth): string {
  return [
    "flex w-full flex-col gap-4 text-start",
    width === "form" ? "mx-auto max-w-[600px]" : "",
  ].join(" ");
}
